/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './footer.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/include/footer/footer.component';
import * as i4 from '@angular/router';
const styles_FooterComponent:any[] = [i0.styles];
export const RenderType_FooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FooterComponent,data:{}});
function View_FooterComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'footer',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      1,'div',[['class','pull-right']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(3,(null as any),['\n    ','\n  '])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),
      0,'div',[['class','clearfix']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.foot;
    _ck(_v,3,0,currVal_0);
  });
}
export function View_FooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_FooterComponent_1)),i1.ɵdid(1,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i3.FooterComponent = _v.component;
    const currVal_0:any = (_co.router.url != '/login');
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_FooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-footer',
      ([] as any[]),(null as any),(null as any),(null as any),View_FooterComponent_0,
      RenderType_FooterComponent)),i1.ɵdid(1,114688,(null as any),0,i3.FooterComponent,
      [i4.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const FooterComponentNgFactory:i1.ComponentFactory<i3.FooterComponent> = i1.ɵccf('app-footer',
    i3.FooterComponent,View_FooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2luY2x1ZGUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9naXRsYWItcnVubmVyL2J1aWxkcy9kOTBjNWJjZi8wL2dhaWEvZ2FpYS11aS1hbmd1bGFyL3NyYy9hcHAvaW5jbHVkZS9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2luY2x1ZGUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2luY2x1ZGUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQudHMuRm9vdGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGZvb3RlciAqbmdJZj1cInJvdXRlci51cmwgIT0gJy9sb2dpbidcIj5cbiAgPGRpdiBjbGFzcz1cInB1bGwtcmlnaHRcIj5cbiAgICB7e2Zvb3R9fVxuICA8L2Rpdj5cbiAgPGRpdiBjbGFzcz1cImNsZWFyZml4XCI+PC9kaXY+XG48L2Zvb3Rlcj5cbiIsIjxhcHAtZm9vdGVyPjwvYXBwLWZvb3Rlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBLHdFQUF1QzthQUFBLDZCQUNyQztNQUFBO01BQUEsZ0JBQXdCLG9EQUVsQjthQUFBLDZCQUNOO01BQUE7TUFBQSxnQkFBNEI7OztJQUhKO0lBQUE7Ozs7b0JBRDFCO01BQUEsZ0NBQUE7b0JBQUEsbUNBS1M7TUFBQTs7SUFMRDtJQUFSLFdBQVEsU0FBUjs7OztvQkNBQTtNQUFBO2dDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/include/footer/footer.component.ngfactory.ts